import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Modal, } from 'react-bootstrap';
import ReligionForm from '../components/forms/ReligionForm';
import '../styles/EmployeeMaster.css';
import ReligionTable from '../components/ReligionTable';

const ReligionModel = () => {
     const navigate = useNavigate();
     const location = useLocation();

     const showModal = location.pathname === '/religion/add';

     const handleAddClick = () => {
          navigate('/religion/add');
     };

     const handleCloseModal = () => {
          navigate('/religion');
     };

     return (
          <div className="employee-master-page">
               <div className="employee-header">
                    <h2>Religion Master</h2>
                    <button className="add-employee-btn" onClick={handleAddClick}>
                         Add Religion
                    </button>
               </div>

               <ReligionTable />

               <Modal
                    show={showModal}
                    onHide={handleCloseModal}
                    size="md"
                    centered
               >
                    <Modal.Header closeButton>
                         <Modal.Title>Add New Religion</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                         <ReligionForm />
                    </Modal.Body>

               </Modal>
          </div>
     );
};

export default ReligionModel;